import React from "react";
import { Link, useParams } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { useQuery } from "@tanstack/react-query";

import useAuthStore from "../../../../store/authStore";
import { useApi } from "../../../../hooks/api/useApi";
import { useThemeChange } from "../../../../utils/themeChange";
import { COLLECTION } from "../../../../constants/api-constants";
import { ListArt } from "../../Art";

const { GET_COLLECTION_DETAIL } = COLLECTION;

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #212428;
  }
`;

const DetailCollection = () => {
  const { collection_id } = useParams();
  const { user } = useAuthStore((state) => ({ user: state.userLog }));
  const { getById, getAll } = useApi();
  const themeChange = useThemeChange();

  const getCollection = useQuery({
    queryKey: ["collection", collection_id],
    queryFn: () => getById(collection_id, GET_COLLECTION_DETAIL),
  });

  const artistArts = useQuery({
    queryKey: ["artistArts"],
    enabled: getCollection?.data != null,
    queryFn: () => getAll(`arts/artist/${getCollection?.data?.artistId}`),
  });

  if (artistArts.isSuccess) {
    const collectionIdToFilter = collection_id;

    var filteredArts = artistArts?.data?.filter(
      (item) => item.collectionId === collectionIdToFilter
    );
  }

  return (
    <div className={themeChange.add("section")}>
      <GlobalStyles />
      <section
        id="profile_banner"
        className="jumbotron breadcumb no-bg no-bg-cover"
        style={{
          backgroundImage: `url(${getCollection?.data?.coverImage})`,
          backgroundSize: "cover",
        }}
      />
      <section className="container d_coll no-top no-bottom">
        <div className="row">
          <div className="col-md-12">
            <div className="d_profile">
              <div className="profile_avatar">
                <div className="d_profile_img">
                  {getCollection?.data?.profileImage ? (
                    <img
                      src={getCollection?.data?.profileImage}
                      alt="collection-profile-img"
                    />
                  ) : (
                    <div className="no-image-alt">
                      <h1>
                        {getCollection?.data?.name
                          ?.match(/\b(\w)/g)
                          ?.join(" ")
                          ?.toUpperCase()}
                      </h1>
                    </div>
                  )}
                </div>

                <div className="profile_name">
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 style={{ marginRight: "10px" }}>
                      {getCollection?.data?.name}
                      <div className="clearfix"></div>
                    </h4>
                    {user?.artist?.id === getCollection?.data?.artistId && (
                      <div>
                        <Link
                          to={`/edit-collection/${getCollection?.data?.id}`}
                          className="options"
                          style={{ marginBottom: "0px" }}
                          state={{ defaultCollection: getCollection?.data }}
                        >
                          <button
                            id="btn_edit"
                            title="Edit Text"
                            style={{ marginLeft: "0px" }}
                          >
                            Edit
                          </button>
                        </Link>
                        {/* <button id="btn_edit" title="Delete NFT">
                          Delete
                        </button> */}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <p style={{ textAlign: "center" }}>
                {getCollection?.data?.description}
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="container no-top mt-5">
        {user?.artist?.id === getCollection?.data?.artistId && (
          <div className="d-flex flex-row-reverse mb-2">
            <Link
              to="/create-art"
              state={{
                defaultCollection: {
                  name: getCollection?.data?.name,
                  id: getCollection?.data?.id,
                },
              }}
              style={{ textDecoration: "none" }}
            >
              <span className="btn-main" style={{ display: "inline-block" }}>
                Add Artwork
              </span>
            </Link>
          </div>
        )}
        {filteredArts ? (
          <div id="zero2" className="onStep fadeIn">
            <ListArt arts={filteredArts} />
          </div>
        ) : (
          <p className="text-center">
            No artwork is yet listed for this Collection.
          </p>
        )}
      </section>
    </div>
  );
};

export default DetailCollection;
